// Fond configurable d'un overlay (couleur OU image), par ressource (Lot 4).
// template_6 fournit `overlayBg` (ref { color, imageSrc }) via provide ; chaque overlay
// applique `overlayBgStyle` sur sa racine.
import { inject, ref, computed } from 'vue';

export function useOverlayBg() {
  const overlayBg = inject('overlayBg', ref({ color: null, imageSrc: null }));
  const overlayBgStyle = computed(() => {
    const b = overlayBg.value || {};
    if (b.imageSrc) {
      return {
        backgroundImage: `url(${b.imageSrc})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      };
    }
    if (b.color) return { backgroundColor: b.color };
    return {};
  });
  return { overlayBgStyle };
}
